// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"DatePickerWithPrices__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/DatePickerWithPrices/DatePickerWithPrices.scss
 ** module id = 910
 ** module chunks = 1
 **/